export default "__VITE_ASSET__Scyo2rFI__"